import { Building2, Users2Icon } from "lucide-react";
import { Navigate, Outlet } from "react-router-dom";

import { SecondaryNavigation } from "@/components/secondary-navigation";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { NavigationGroup } from "@/types/navigation";
import { RoleEnum } from "@classview/shared-types";

/**
 * Layout for viewing an organisation as a super admin
 */
export function SettingsLayout() {
  const { hasPermission } = useOrganisation();

  const navigation: NavigationGroup[] = [
    {
      name: "Organisation Settings",
      icon: Building2,
      elements: [
        ...(hasPermission([RoleEnum.ORGANISATION_MANAGEMENT])
          ? [{ name: "Details", href: `/settings/details` }]
          : []),
        { name: "Licence", href: `/settings/licence` },
        ...(hasPermission([RoleEnum.REPLAY, RoleEnum.REPLAY_ADVANCED])
          ? [{ name: "Tags", href: `/settings/tags` }]
          : []),
        ...(hasPermission([RoleEnum.ORGANISATION_MANAGEMENT])
          ? [{ name: "Event Categories", href: `/settings/event-categories` }]
          : []),
        ...(hasPermission([
          RoleEnum.REPLAY,
          RoleEnum.REPLAY_ADVANCED,
          RoleEnum.ORGANISATION_MANAGEMENT,
        ])
          ? [{ name: "Replay", href: `/settings/replay` }]
          : []),
        ...(hasPermission([RoleEnum.ORGANISATION_MANAGEMENT])
          ? [{ name: "Room Systems", href: `/settings/room-systems` }]
          : []),
      ],
    },
    {
      name: "User Management",
      icon: Users2Icon,
      elements: [
        { name: "Users", href: `/settings/users` },
        { name: "Invitations", href: `/settings/invitations` },
      ],
    },
  ];

  if (!hasPermission(RoleEnum.USER_MANAGEMENT)) {
    return <Navigate to="/" />;
  }

  return (
    <div>
      <div className="grid grid-cols-12 gap-x-8">
        <div className="hidden md:col-span-3 md:block">
          <SecondaryNavigation navigations={navigation} />
        </div>
        <div className="col-span-12 md:col-span-9">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
